import { tkParse } from '@moke/vue-tk'
// import viewPage from '../component/viewPage.vue'
export default {
  className: 'selfPoint',
  render: (record) => {
    return record.name
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '小区不可为空'
      ]
    },
    {
      name: 'address',
      validators: [
        (val) => val ? null : '地址不可为空'
      ]
    },
    {
      name: 'phone',
      render: (record) => {
        return (record && record.phone) || '-'
      }
    }
  ],
  search: [
    'name'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = {
        $ne: true
      }
    },
    async beforeInsert ({ data }) {
      let { data: res } = await tkParse.get('/classes/selfPoint', {
        params: {
          where: {
            name: data.name
          }
        }
      })
      if (res.results.length) {
        throw new Error('自提点已存在')
      }
    }
  },
  action: {
    // view: {
    //   type: 'row',
    //   text: '查看',
    //   component: viewPage
    // },
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm }) => {
        await vm.confirm('警告', '确认删除这条记录吗?')
        try {
          await tkParse.put(`/classes/selfPoint/${record.objectId}`, {
            isDelete: true
          })
          vm.$notification['success']({
            message: '操作成功',
            description: '删除成功'
          })
          vm.refresh()
        } catch (e) {
          console.log('删除自提点异常', e)
          vm.$notification['error']({
            message: '操作失败',
            description: '网络错误,请重试'
          })
        }
      }
    }
  }
}
